import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCanvasGrid: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCanvasGrid"><Path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V3H21V21ZM11 19.5H13V17H11V19.5ZM11 9V11H9V13H11V15H13V13H15V11H13V9H11ZM4.5 13H7V11H4.5V13ZM17 13H19.5V11H17V13ZM11 7H13V4.5H11V7Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCanvasGrid;
